import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Colours } from '../../tokens';
import SVG from '../SVG';
const useStyles = createUseStyles({
    root: {
        color: Colours.primary,
    },
});
const CricleTickIcon = ({ className }) => {
    const styles = useStyles();
    return (React.createElement(SVG, { width: "16", height: "16", viewBox: "0 0 16 16", className: classNames(styles.root, className) },
        React.createElement("g", { transform: "translate(-236 -252)" },
            React.createElement("g", { transform: "translate(236 252)" },
                React.createElement("path", { d: "M7.167,14.333a7.167,7.167,0,1,1,7.167-7.167A7.173,7.173,0,0,1,7.167,14.333ZM7.167,1a6.167,6.167,0,1,0,6.167,6.167A6.174,6.174,0,0,0,7.167,1Z", transform: "translate(0.833 0.833)", fill: "currentColor" }),
                React.createElement("path", { d: "M.5,4.772a.494.494,0,0,1-.353-.147.5.5,0,0,1,0-.707L3.918.145a.5.5,0,1,1,.707.707L.852,4.625A.484.484,0,0,1,.5,4.772Z", transform: "translate(5.615 5.615)", fill: "currentColor" }),
                React.createElement("path", { d: "M4.272,4.772a.494.494,0,0,1-.353-.147L.145.852A.5.5,0,0,1,.852.145L4.625,3.918a.5.5,0,0,1,0,.707A.494.494,0,0,1,4.272,4.772Z", transform: "translate(5.615 5.615)", fill: "currentColor" }),
                React.createElement("path", { d: "M0,0H16V16H0Z", fill: "none", opacity: "0" })))));
};
export default CricleTickIcon;
//# sourceMappingURL=CircleCloseIcon.js.map